import { gql } from 'types/__generated__/gql';

const KEY_ACTIVE_STUDENT_REPORT_QUERY = gql(/* GraphQL */ `
  query keyActiveStudentsReport($where: KeyReportWhereInput!, $dateRange: DateRangeInput!) {
    keyActiveStudentsReport(where: $where, dateRange: $dateRange) {
      activeStudentCount
      totalStudentCount
    }
  }
`);

export default KEY_ACTIVE_STUDENT_REPORT_QUERY;
